const images = {
  example: require('./home-screen/example.png'),
  example4: require('./home-screen/example-4.png'),
  exampleBanner1: require('./home-screen/example-banner-1.png'),
  exampleBanner2: require('./home-screen/example-banner-2.png'),
  exampleBanner3: require('./home-screen/example-banner-3.png'),
  example2: require('./home-screen/example-2.png'),
  exampleImgPlan: require('./home-screen/example-img-plan.png'),
  logoExample: require('./home-screen/logos/logo-example.png'),
  logoExample2: require('./home-screen/logos/logo-example-2.png'),
  logoExample3: require('./home-screen/logos/logo-example-3.png'),

  bannerHome: require('./home-screen/banner-home.png'),
  bannerConsumer: require('./home-screen/banner-consumer.png'),
  bannerDefi: require('./home-screen/banner-defi.png'),
  bannerGaming: require('./home-screen/banner-gaming.png'),
  bannerCommunity: require('./home-screen/banner-community.png'),
  expandingVision: require('./home-screen/expanding-vision.png'),
  victonVideo: require('./home-screen/viction-video.jpg'),
  victionHorizon: require('./home-screen/viction-horizon.png'),
  saigonBuilder: require('./home-screen/saigon-builder.png'),
  tomoBuilder: require('./home-screen/tomo-builder.png'),
  slideBanner1: require('./home-screen/slide-banner-1.png'),
  slideBanner2: require('./home-screen/slide-banner-2.png'),
  slideBanner3: require('./home-screen/slide-banner-3.png'),
  slideBanner4: require('./home-screen/slide-banner-4.png'),
  slideBanner5: require('./home-screen/slide-banner-5.png'),
  bannerNetwork: require('./banner/banner-network.png'),
  bannerNetwork2: require('./banner/banner-network-2.png'),
  bannerNetwork3: require('./banner/banner-network-3.png'),
  bannerNetwork4: require('./banner/banner-network-4.png'),
  bannerNetwork5: require('./banner/banner-network-5.png'),
  bannerNetwork6: require('./banner/banner-network-6.png'),
  bannerSolution: require('./banner/banner-solution.png'),
  bannerConsumer1: require('./banner/banner-consumer.png'),
  bannerConsumer2: require('./banner/banner-consumer-2.png'),
  bannerGaming1: require('./banner/banner-gaming.png'),
  bannerGaming2: require('./banner/banner-gaming-2.png'),
  bannerGaming3: require('./banner/banner-gaming-3.png'),
  bannerDefi1: require('./banner/banner-defi.png'),

  binance: require('./home-screen/logo-ecosystem/binance.png'),
  btse: require('./home-screen/logo-ecosystem/btse.png'),
  bingX: require('./home-screen/logo-ecosystem/bingx-logo.png'),
  chainlinkLogo: require('./home-screen/logo-ecosystem/chain-link-logo.png'),
  bitget: require('./home-screen/logo-ecosystem/bidget-logo.png'),
  gateIo: require('./home-screen/logo-ecosystem/gate-logo.png'),
  mexc: require('./home-screen/logo-ecosystem/mexc-logo.png'),
  alchemy: require('./home-screen/logo-ecosystem/alchemy-pay-logo.png'),
  baryon: require('./home-screen/logo-ecosystem/baryon-logo.png'),
  biconomy: require('./home-screen/logo-ecosystem/biconomy-logo.png'),
  cobo: require('./home-screen/logo-ecosystem/cobo-logo.png'),
  dagora: require('./home-screen/logo-ecosystem/dagora-logo.png'),
  herond: require('./home-screen/logo-ecosystem/herond-logo.png'),
  impossible: require('./home-screen/logo-ecosystem/impossible-logo.png'),
  intOverse: require('./home-screen/logo-ecosystem/into-overse-logo.png'),
  layerZero: require('./home-screen/logo-ecosystem/layer-zero-logo.png'),
  metaOne: require('./home-screen/logo-ecosystem/meta-one-logo.png'),
  moonPay: require('./home-screen/logo-ecosystem/moon-pay-logo.png'),
  nowNodes: require('./home-screen/logo-ecosystem/now-nodes-logo.png'),
  poko: require('./home-screen/logo-ecosystem/poko-logo.png'),
  provalidator: require('./home-screen/logo-ecosystem/provalidator-logo.png'),
  pyth: require('./home-screen/logo-ecosystem/pyth-logo.png'),
  questN: require('./home-screen/logo-ecosystem/questN-logo.png'),
  ramper: require('./home-screen/logo-ecosystem/ramper-logo.png'),
  reneVerse: require('./home-screen/logo-ecosystem/rene-verse-logo.png'),
  rockX: require('./home-screen/logo-ecosystem/rockX-logo.png'),
  simplex: require('./home-screen/logo-ecosystem/simplex-logo.png'),
  stably: require('./home-screen/logo-ecosystem/stably-logo.png'),
  stealthEx: require('./home-screen/logo-ecosystem/stealth-ex-logo.png'),
  tezuka: require('./home-screen/logo-ecosystem/tezuka-logo.png'),
  tokenChart: require('./home-screen/logo-ecosystem/token-chart-logo.png'),
  blockPi: require('./home-screen/logo-ecosystem/blockPi-logo.png'),
  covalent: require('./home-screen/logo-ecosystem/covalent-logo.png'),
  particalNetwork: require('./home-screen/logo-ecosystem/partical-network-logo.png'),
  poolz: require('./home-screen/logo-ecosystem/poolz-logo.png'),
  space3: require('./home-screen/logo-ecosystem/space3-logo.png'),
  oneId: require('./home-screen/logo-ecosystem/oneID-logo.png'),
  forwards: require('./home-screen/logo-ecosystem/forwards-logo.png'),
  dojoSwap: require('./home-screen/logo-ecosystem/dojoSwap-logo.png'),
  aliniex: require('./home-screen/logo-ecosystem/aliniex-logo.png'),
  escrowDapp: require('./home-screen/logo-ecosystem/escrowdapp-logo.png'),
  desig: require('./home-screen/logo-ecosystem/desig-logo.png'),
  aitProtocolLogo: require('./home-screen/logo-ecosystem/ait-protocol-logo.png'),
  coin98SuperWalletLogo: require('./home-screen/logo-ecosystem/coin98-super-wallet-logo.png'),
  nftScanLogo: require('./home-screen/logo-ecosystem/nft-scan-logo.png'),
  nuvoLogo: require('./home-screen/logo-ecosystem/nuvo-logo.png'),
  soullyLogo: require('./home-screen/logo-ecosystem/soully-logo.png'),
  starshipLogo: require('./home-screen/logo-ecosystem/starship-logo.png'),
  veloLogo: require('./home-screen/logo-ecosystem/velo-logo.png'),
  victionLogo: require('./home-screen/logo-ecosystem/viction-logo.png'),
  wooXLogo: require('./home-screen/logo-ecosystem/woo-x-logo.png'),
  bitesLogo: require('./home-screen/logo-ecosystem/bites-logo.png'),
  bitMartLogo: require('./home-screen/logo-ecosystem/bit-mart-logo.png'),
  bitizenWalletLogo: require('./home-screen/logo-ecosystem/bitizen-wallet-logo.png'),
  bybitLogo: require('./home-screen/logo-ecosystem/bybit-logo.png'),
  chainsAtlasLogo: require('./home-screen/logo-ecosystem/chains-atlas-logo.png'),
  cocoCatLogo: require('./home-screen/logo-ecosystem/cocoCat-logo.png'),
  cusdLogo: require('./home-screen/logo-ecosystem/cusd-logo.png'),
  d3Logo: require('./home-screen/logo-ecosystem/d3-logo.png'),
  moriProtocolLogo: require('./home-screen/logo-ecosystem/mori-protocol-logo.png'),
  foxWalletLogo: require('./home-screen/logo-ecosystem/fox-wallet-logo.png'),
  giottusLogo: require('./home-screen/logo-ecosystem/giottus-logo.png'),
  htxLogo: require('./home-screen/logo-ecosystem/htx-logo.png'),
  humanodeLogo: require('./home-screen/logo-ecosystem/humanode-logo.png'),
  hyperlaneLogo: require('./home-screen/logo-ecosystem/hyperlane-logo.png'),
  magicSquareLogo: require('./home-screen/logo-ecosystem/magic-square-logo.png'),
  mudAILogo: require('./home-screen/logo-ecosystem/mudAI-logo.png'),
  taskOnLogo: require('./home-screen/logo-ecosystem/taskOn-logo.png'),
  arkenBridgeLogo: require('./home-screen/logo-ecosystem/arken-bridge-logo.png'),
  ceffuLogo: require('./home-screen/logo-ecosystem/ceffu-logo.png'),
  firstDigitalLabsLogo: require('./home-screen/logo-ecosystem/first-digital-labs-logo.png'),
  tmrGamesLogo: require('./home-screen/logo-ecosystem/tmrgames-logo.png'),
  usdvLogo: require('./home-screen/logo-ecosystem/usdv-logo.png'),
  tezukaLogo: require('./home-screen/logo-ecosystem/tezuka-logo.png'),
  authariumLogo: require('./home-screen/logo-ecosystem/autharium-logo.png'),
  chat3Logo: require('./home-screen/logo-ecosystem/chat-3-logo.png'),
  deFusionLogo: require('./home-screen/logo-ecosystem/deFusion-logo.png'),
  geckoTerminalLogo: require('./home-screen/logo-ecosystem/gecko-terminal-logo.png'),
  holdStationLogo: require('./home-screen/logo-ecosystem/hold-station-logo.png'),
  plenaLogo: require('./home-screen/logo-ecosystem/plena-logo.png'),
  micro3Logo: require('./home-screen/logo-ecosystem/project-82-logo.png'),
  simpleSwapLogo: require('./home-screen/logo-ecosystem/simple-swap-logo.png'),
  townStoryLogo: require('./home-screen/logo-ecosystem/town-story-logo.png'),
  cyborgLogo: require('./home-screen/logo-ecosystem/cyborg-logo.png'),
  hybrixLogo: require('./home-screen/logo-ecosystem/hybrix-logo.png'),
  krystalLogo: require('./home-screen/logo-ecosystem/krystal-logo.png'),
  mathWalletLogo: require('./home-screen/logo-ecosystem/math-wallet-logo.png'),
  midleLogo: require('./home-screen/logo-ecosystem/midle-logo.png'),
  sendTokensLogo: require('./home-screen/logo-ecosystem/sendTokens-logo.png'),
  solideLogo: require('./home-screen/logo-ecosystem/solide-logo.png'),
  subWalletLogo: require('./home-screen/logo-ecosystem/subWallet-logo.png'),
  wigwam: require('./home-screen/logo-ecosystem/wigwam.png'),
  revoke: require('./home-screen/logo-ecosystem/revoke.png'),
  omniHub: require('./home-screen/logo-ecosystem/omniHub.png'),
  woD: require('./home-screen/logo-ecosystem/woD.png'),
  lumoz: require('./home-screen/logo-ecosystem/lumoz.png'),
  polygon: require('./home-screen/logo-ecosystem/polygon.png'),
  nfts2me: require('./home-screen/logo-ecosystem/nfts2me.png'),
  ivy: require('./home-screen/logo-ecosystem/ivy.png'),
  contrarians: require('./home-screen/logo-ecosystem/contrarians.png'),
  chainlyze: require('./home-screen/logo-ecosystem/chainlyze.png'),
  zeroway: require('./home-screen/logo-ecosystem/zeroway.png'),
  stakeKit: require('./home-screen/logo-ecosystem/stakeKit.png'),
  blockWallet: require('./home-screen/logo-ecosystem/blockWallet.png'),
  blazpay: require('./home-screen/logo-ecosystem/blazpay.png'),
  cedeStore: require('./home-screen/logo-ecosystem/cedeStore.png'),
  omnisea: require('./home-screen/logo-ecosystem/omnisea.png'),
  l2Marathon: require('./home-screen/logo-ecosystem/l2Marathon.png'),
  meendart: require('./home-screen/logo-ecosystem/meendart.png'),
  quickIntel: require('./home-screen/logo-ecosystem/quickIntel.png'),
  eternals: require('./home-screen/logo-ecosystem/eternals.png'),
  domin: require('./home-screen/logo-ecosystem/domin.png'),
  domin: require('./home-screen/logo-ecosystem/domin.png'),
  galxe: require('./home-screen/logo-ecosystem/galxe.png'),
  glitchD: require('./home-screen/logo-ecosystem/glitchD.png'),
  interport: require('./home-screen/logo-ecosystem/interport.png'),

  // wallet-screen
  backgroundWallet: require('./wallet-screen/background-wallet.png'),
  backgroundWalletMobile: require('./wallet-screen/background-wallet-mobile.png'),
  backgroundWallet1: require('./wallet-screen/background-wallet-1.svg').default,
  backgroundWallet2: require('./wallet-screen/background-wallet-2.svg').default,
  backgroundWallet3: require('./wallet-screen/background-wallet-3.svg').default,
  backgroundWallet4: require('./wallet-screen/background-wallet-4.svg').default,
  screenSendWallet: require('./wallet-screen/screen-send-wallet.png'),
  screenConnect: require('./wallet-screen/screen-connect.png'),
  screenMainWallet: require('./wallet-screen/screen-main-wallet.png'),
  screenDappWallet: require('./wallet-screen/screen-dapp-wallet.png'),

  //wwc
  bgBanner: require('./world-wide-chain/bg-banner.png'),
  connectDots: require('./world-wide-chain/connect-dots.png'),
  wwc1: require('./world-wide-chain/wwc-1.png'),
  wwc2: require('./world-wide-chain/wwc-2.png'),
  wwc3: require('./world-wide-chain/wwc-3.png'),
  oneStop: require('./world-wide-chain/one-stop.png'),
  liberalImg: require('./world-wide-chain/liberal-img.png'),
  liberalImgMobile: require('./world-wide-chain/liberal-img-mobile.png'),
  gameImg: require('./world-wide-chain/game-img.png'),
  socialImg: require('./world-wide-chain/social-img.png'),
  nftImg: require('./world-wide-chain/nft-img.png'),
  gameImgMobile: require('./world-wide-chain/game-img-mobile.png'),
  socialImgMobile: require('./world-wide-chain/social-img-mobile.png'),
  nftImgMobile: require('./world-wide-chain/nft-img-mobile.png'),
  bgFooter: require('./world-wide-chain/bg-footer.png'),
  circleDot1: require('./world-wide-chain/circle-dot-1.png'),
  circleDot2: require('./world-wide-chain/circle-dot-2.png'),
  circleDot3: require('./world-wide-chain/circle-dot-3.png'),
  circleDot4: require('./world-wide-chain/circle-dot-4.png'),
  efficiency: require('./world-wide-chain/efficiency-1.png'),
  interoperability: require('./world-wide-chain/interoperability.png'),
  scalability: require('./world-wide-chain/scalability.png'),
  security: require('./world-wide-chain/security.png'),
  patternUp: require('./world-wide-chain/vic-pattern-up.png'),
  victionText: require('./world-wide-chain/viciton-text.svg').default,
  bgStarted: require('./world-wide-chain/bg-started.png'),

  // stable coin
  imgCoin: require('./stable-coin/img-coin.png'),
  appPay1: require('./stable-coin/app-pay-1.png'),
  appPay2: require('./stable-coin/app-pay-2.png'),
  appPay3: require('./stable-coin/app-pay-3.png'),
  hand1: require('./stable-coin/hand-1.png'),
  hand2: require('./stable-coin/hand-2.png'),
  circle1: require('./stable-coin/circle-1.png'),
  circle2: require('./stable-coin/circle-2.png'),
  circle3: require('./stable-coin/circle-3.png'),
  circle4: require('./stable-coin/circle-4.png'),
  bgWhite: require('./stable-coin/bg-white.png'),
  circleDown1: require('./stable-coin/circle-down-1.png'),
  circleDown2: require('./stable-coin/circle-down-2.png'),
  circleDown3: require('./stable-coin/circle-down-3.png'),
  circleDown4: require('./stable-coin/circle-down-4.png'),
  circle51: require('./stable-coin/circle-5-1.png'),
  circle52: require('./stable-coin/circle-5-2.png'),
  circle53: require('./stable-coin/circle-5-3.png'),
  circle54: require('./stable-coin/circle-5-4.png'),
  wspn: require('./stable-coin/wspn.png'),
  starship: require('./stable-coin/starship.png'),
  coin98: require('./stable-coin/coin98.png'),
  dagora: require('./stable-coin/dagora.png'),
  tether: require('./stable-coin/tether.png'),
  oneId: require('./stable-coin/oneId.png'),
  rabbit: require('./stable-coin/rabbit.png'),
  walkOut1: require('./stable-coin/walk-out-1.png'),
  walkOut2: require('./stable-coin/walk-out-2.png'),
  moneyFree1: require('./stable-coin/money-free-1.png'),
  moneyFree2: require('./stable-coin/money-free-2.png'),
  moneyFree3: require('./stable-coin/money-free-3.png'),
  moneyFree4: require('./stable-coin/money-free-4.png'),
  localCity: require('./stable-coin/local-city.png'),
  zeroGas: require('./stable-coin/zero-gas.png'),
  alixPay: require('./stable-coin/alix-pay.png'),
  backgroundFt: require('./stable-coin/background-ft.png'),
  vnd: require('./stable-coin/vnd.png'),
  usdt: require('./stable-coin/usdt.png'),
  wusd: require('./stable-coin/wusd.png'),

  //! img new
  headerIcon1: require('./header-icon-1.svg').default,
  headerIcon2: require('./header-icon-2.svg').default,
  headerIcon3: require('./header-icon-3.svg').default,
  headerIcon4: require('./header-icon-4.svg').default,
  headerIconToken: require('./header-icon-token.png'),

  curveWhiteUp: require('./home-new/curve-white-up.png'),
  bgBanner1: require('./home-new/bg-banner-1.png'),
  bgBanner2: require('./home-new/bg-banner-2.png'),
  iconMasternode: require('./home-new/icon-masternode.svg').default,

  defiHub: require('./home-new/defi-hub.png'),
  gamePower: require('./home-new/game-power.png'),
  nftFandom: require('./home-new/nft-fandom.png'),
  globalPayment: require('./home-new/global-payment.png'),

  //* ecosystem new
  eco1: require('./home-new/ecosystem//eco-1.png'),
  eco2: require('./home-new/ecosystem//eco-2.png'),
  eco3: require('./home-new/ecosystem//eco-3.png'),
  eco4: require('./home-new/ecosystem//eco-4.png'),
  eco5: require('./home-new/ecosystem//eco-5.png'),
  eco6: require('./home-new/ecosystem//eco-6.png'),
  eco7: require('./home-new/ecosystem//eco-7.png'),
  eco8: require('./home-new/ecosystem//eco-8.png'),
  eco9: require('./home-new/ecosystem//eco-9.png'),
  eco10: require('./home-new/ecosystem//eco-10.png'),
  eco11: require('./home-new/ecosystem//eco-11.png'),
  eco12: require('./home-new/ecosystem//eco-12.png'),
  eco13: require('./home-new/ecosystem//eco-13.png'),
  eco14: require('./home-new/ecosystem//eco-14.png'),
  eco15: require('./home-new/ecosystem//eco-15.png'),
  eco16: require('./home-new/ecosystem//eco-16.png'),
  eco17: require('./home-new/ecosystem//eco-17.png'),
  eco18: require('./home-new/ecosystem//eco-18.png'),
  eco19: require('./home-new/ecosystem//eco-19.png'),
  eco20: require('./home-new/ecosystem//eco-20.png'),
  eco21: require('./home-new/ecosystem//eco-21.png'),
  eco22: require('./home-new/ecosystem//eco-22.png'),
  eco23: require('./home-new/ecosystem//eco-23.png'),
  eco24: require('./home-new/ecosystem//eco-24.png'),
  eco25: require('./home-new/ecosystem//eco-25.png'),

  curveBlack: require('./home-new/curve-black.png'),
  curveBlackUp: require('./home-new/curve-black-up.png'),
  user1: require('./home-new/user-1.png'),
  user2: require('./home-new/user-2.png'),
  tokenVic: require('./home-new/token-vic.png'),
  circleNew1: require('./home-new/circle-1.png'),
  circleNew2: require('./home-new/circle-2.png'),
  circleNew3: require('./home-new/circle-3.png'),
  circleNew4: require('./home-new/circle-4.png'),

  vicLogo1: require('./home-new/logo/vic-logo-1.png'),
  vicLogo2: require('./home-new/logo/vic-logo-2.png'),
  vicLogo3: require('./home-new/logo/vic-logo-3.png'),
  vicLogo4: require('./home-new/logo/vic-logo-4.png'),
  vicLogo5: require('./home-new/logo/vic-logo-5.png'),
  vicLogo6: require('./home-new/logo/vic-logo-6.png'),
  vicLogo7: require('./home-new/logo/vic-logo-7.png'),
  vicLogo8: require('./home-new/logo/vic-logo-8.png'),
  vicLogo9: require('./home-new/logo/vic-logo-9.png'),
  vicLogo10: require('./home-new/logo/vic-logo-10.png'),
  vicLogo11: require('./home-new/logo/vic-logo-11.png'),
  vicLogo12: require('./home-new/logo/vic-logo-12.png'),
  vicLogo13: require('./home-new/logo/vic-logo-13.png'),
  vicLogo14: require('./home-new/logo/vic-logo-14.png'),
  vicLogo15: require('./home-new/logo/vic-logo-15.png'),
  vicLogo16: require('./home-new/logo/vic-logo-16.png'),
  vicLogo17: require('./home-new/logo/vic-logo-17.png'),
  vicLogo18: require('./home-new/logo/vic-logo-18.png'),
  vicLogo19: require('./home-new/logo/vic-logo-19.png'),
  vicLogo20: require('./home-new/logo/vic-logo-20.png'),
  vicLogo21: require('./home-new/logo/vic-logo-21.png'),
  vicLogo22: require('./home-new/logo/vic-logo-22.png'),
  vicLogo23: require('./home-new/logo/vic-logo-23.png'),
  vicLogo24: require('./home-new/logo/vic-logo-24.png'),
  vicLogo25: require('./home-new/logo/vic-logo-25.png'),
  vicLogo26: require('./home-new/logo/vic-logo-26.png'),
  vicLogo27: require('./home-new/logo/vic-logo-27.png'),
  vicLogo28: require('./home-new/logo/vic-logo-28.png'),
  vicLogo29: require('./home-new/logo/vic-logo-29.png'),
  vicLogo30: require('./home-new/logo/vic-logo-30.png'),
  vicLogo31: require('./home-new/logo/vic-logo-31.png'),
  vicLogo32: require('./home-new/logo/vic-logo-32.png'),
  vicLogo33: require('./home-new/logo/vic-logo-33.png'),
  vicLogo34: require('./home-new/logo/vic-logo-34.png'),
  vicLogo35: require('./home-new/logo/vic-logo-35.png'),
  vicLogo36: require('./home-new/logo/vic-logo-36.png'),
  vicLogo37: require('./home-new/logo/vic-logo-37.png'),
  vicLogo38: require('./home-new/logo/vic-logo-38.png'),
  vicLogo39: require('./home-new/logo/vic-logo-39.png'),
  vicLogo40: require('./home-new/logo/vic-logo-40.png'),
  vicLogo41: require('./home-new/logo/vic-logo-41.png'),
  vicLogoRabbit: require('./home-new/logo/vic-logo-rabbit.png'),
  logoFrontier: require('./home-new/logo-frontier.png'),

  community1: require('./home-new/community-1.png'),
  community2: require('./home-new/community-2.png'),
  community3: require('./home-new/community-3.png'),
  community4: require('./home-new/community-4.png'),
  community5: require('./home-new/community-5.png'),

  flag1: require('./home-new/flag/flag-1.png'),
  flag2: require('./home-new/flag/flag-2.png'),
  flag3: require('./home-new/flag/flag-3.png'),
  flag4: require('./home-new/flag/flag-4.png'),
  flag5: require('./home-new/flag/flag-5.png'),
  flag6: require('./home-new/flag/flag-6.png'),
  flag7: require('./home-new/flag/flag-7.png'),

  //* ecosystem revamp
  ecoBanner1: require('./ecosystem-new/eco-new-banner-1.png'),
  ecoBanner2: require('./ecosystem-new/eco-new-banner-2.png'),
  ecoBanner3: require('./ecosystem-new/eco-new-banner-3.png'),
  ecoNewBanner: require('./ecosystem-new/eco-new-banner.png'),
  curveBottomBlack: require('./ecosystem-new/curve-bottom-black.png'),
  partnerLogo1: require('./ecosystem-new/partner-logo-1.png'),
  partnerLogo2: require('./ecosystem-new/partner-logo-2.png'),
  partnerLogo3: require('./ecosystem-new/partner-logo-3.png'),
  partnerLogo4: require('./ecosystem-new/partner-logo-4.png'),
  quote: require('./ecosystem-new/quote-icon.png'),

  ecoWallet1: require('./ecosystem-new/project-logo/eco-wallet-1.png'),
  ecoWallet2: require('./ecosystem-new/project-logo/eco-wallet-2.png'),
  ecoWallet3: require('./ecosystem-new/project-logo/eco-wallet-3.png'),
  ecoWallet4: require('./ecosystem-new/project-logo/eco-wallet-4.png'),
  ecoWallet5: require('./ecosystem-new/project-logo/eco-wallet-5.png'),
  ecoWallet6: require('./ecosystem-new/project-logo/eco-wallet-6.png'),
  ecoWallet7: require('./ecosystem-new/project-logo/eco-wallet-7.png'),
  ecoWallet8: require('./ecosystem-new/project-logo/eco-wallet-8.png'),
  ecoWallet9: require('./ecosystem-new/project-logo/eco-wallet-9.png'),
  ecoWallet10: require('./ecosystem-new/project-logo/eco-wallet-10.png'),
  ecoWallet11: require('./ecosystem-new/project-logo/eco-wallet-11.png'),
  ecoWallet12: require('./ecosystem-new/project-logo/eco-wallet-12.png'),
  ecoWallet13: require('./ecosystem-new/project-logo/eco-wallet-13.png'),
  ecoWallet14: require('./ecosystem-new/project-logo/eco-wallet-14.png'),
  ecoWallet15: require('./ecosystem-new/project-logo/eco-wallet-15.png'),
  ecoWallet16: require('./ecosystem-new/project-logo/eco-wallet-16.png'),
  ecoWallet17: require('./ecosystem-new/project-logo/eco-wallet-17.png'),
  ecoWallet18: require('./ecosystem-new/project-logo/eco-wallet-18.png'),
  ecoWallet19: require('./ecosystem-new/project-logo/eco-wallet-19.png'),
  ecoWallet20: require('./ecosystem-new/project-logo/eco-wallet-20.png'),
  ecoWallet21: require('./ecosystem-new/project-logo/eco-wallet-21.png'),
  ecoWallet22: require('./ecosystem-new/project-logo/eco-wallet-22.png'),
  ecoWallet23: require('./ecosystem-new/project-logo/eco-wallet-23.png'),
  ecoWallet24: require('./ecosystem-new/project-logo/eco-wallet-24.png'),
  ecoWallet25: require('./ecosystem-new/project-logo/eco-wallet-25.png'),
  ecoWallet26: require('./ecosystem-new/project-logo/eco-wallet-26.png'),
  ecoWallet27: require('./ecosystem-new/project-logo/eco-wallet-27.png'),
  ecoWallet28: require('./ecosystem-new/project-logo/eco-wallet-28.png'),
  ecoWallet29: require('./ecosystem-new/project-logo/eco-wallet-29.png'),
  ecoWallet30: require('./ecosystem-new/project-logo/eco-wallet-30.png'),
  ecoWallet31: require('./ecosystem-new/project-logo/eco-wallet-31.png'),
  ecoWallet32: require('./ecosystem-new/project-logo/eco-wallet-32.png'),
  ecoWallet33: require('./ecosystem-new/project-logo/eco-wallet-33.png'),
  ecoWallet34: require('./ecosystem-new/project-logo/eco-wallet-34.png'),

  ecoAppTool1: require('./ecosystem-new/project-logo/eco-app-tool-1.png'),
  ecoAppTool2: require('./ecosystem-new/project-logo/eco-app-tool-2.png'),
  ecoAppTool3: require('./ecosystem-new/project-logo/eco-app-tool-3.png'),
  ecoAppTool4: require('./ecosystem-new/project-logo/eco-app-tool-4.png'),
  ecoAppTool5: require('./ecosystem-new/project-logo/eco-app-tool-5.png'),
  ecoAppTool6: require('./ecosystem-new/project-logo/eco-app-tool-6.png'),
  ecoAppTool7: require('./ecosystem-new/project-logo/eco-app-tool-7.png'),
  ecoAppTool8: require('./ecosystem-new/project-logo/eco-app-tool-8.png'),
  ecoAppTool9: require('./ecosystem-new/project-logo/eco-app-tool-9.png'),
  ecoAppTool10: require('./ecosystem-new/project-logo/eco-app-tool-10.png'),
  ecoAppTool11: require('./ecosystem-new/project-logo/eco-app-tool-11.png'),
  ecoAppTool12: require('./ecosystem-new/project-logo/eco-app-tool-12.png'),
  ecoAppTool13: require('./ecosystem-new/project-logo/eco-app-tool-13.png'),
  ecoAppTool14: require('./ecosystem-new/project-logo/eco-app-tool-14.png'),
  ecoAppTool15: require('./ecosystem-new/project-logo/eco-app-tool-15.png'),
  ecoAppTool16: require('./ecosystem-new/project-logo/eco-app-tool-16.png'),
  ecoAppTool17: require('./ecosystem-new/project-logo/eco-app-tool-17.png'),
  ecoAppTool18: require('./ecosystem-new/project-logo/eco-app-tool-18.png'),
  ecoAppTool19: require('./ecosystem-new/project-logo/eco-app-tool-19.png'),
  ecoAppTool20: require('./ecosystem-new/project-logo/eco-app-tool-20.png'),
  ecoAppTool21: require('./ecosystem-new/project-logo/eco-app-tool-21.png'),
  ecoAppTool22: require('./ecosystem-new/project-logo/eco-app-tool-22.png'),
  ecoAppTool23: require('./ecosystem-new/project-logo/eco-app-tool-23.png'),
  ecoAppTool24: require('./ecosystem-new/project-logo/eco-app-tool-24.png'),
  ecoAppTool25: require('./ecosystem-new/project-logo/eco-app-tool-25.png'),
  ecoAppTool26: require('./ecosystem-new/project-logo/eco-app-tool-26.png'),
  ecoAppTool27: require('./ecosystem-new/project-logo/eco-app-tool-27.png'),
  ecoAppTool28: require('./ecosystem-new/project-logo/eco-app-tool-28.png'),
  ecoAppTool29: require('./ecosystem-new/project-logo/eco-app-tool-29.png'),
  ecoAppTool30: require('./ecosystem-new/project-logo/eco-app-tool-30.png'),
  ecoAppTool31: require('./ecosystem-new/project-logo/eco-app-tool-31.png'),

  ecoPayment1: require('./ecosystem-new/project-logo/eco-payment-1.png'),
  ecoPayment2: require('./ecosystem-new/project-logo/eco-payment-2.png'),
  ecoPayment3: require('./ecosystem-new/project-logo/eco-payment-3.png'),
  ecoPayment4: require('./ecosystem-new/project-logo/eco-payment-4.png'),
  ecoPayment5: require('./ecosystem-new/project-logo/eco-payment-5.png'),
  ecoPayment6: require('./ecosystem-new/project-logo/eco-payment-6.png'),
  ecoPayment7: require('./ecosystem-new/project-logo/eco-payment-7.png'),
  ecoPayment8: require('./ecosystem-new/project-logo/eco-payment-8.png'),

  ecoBridge1: require('./ecosystem-new/project-logo/eco-bridge-1.png'),
  ecoBridge2: require('./ecosystem-new/project-logo/eco-bridge-2.png'),
  ecoBridge3: require('./ecosystem-new/project-logo/eco-bridge-3.png'),
  ecoBridge4: require('./ecosystem-new/project-logo/eco-bridge-4.png'),
  ecoBridge5: require('./ecosystem-new/project-logo/eco-bridge-5.png'),
  ecoBridge6: require('./ecosystem-new/project-logo/eco-bridge-6.png'),
  ecoBridge7: require('./ecosystem-new/project-logo/eco-bridge-7.png'),
  ecoBridge8: require('./ecosystem-new/project-logo/eco-bridge-8.png'),
  ecoBridge9: require('./ecosystem-new/project-logo/eco-bridge-9.png'),

  ecoDefi1: require('./ecosystem-new/project-logo/eco-defi-1.png'),
  ecoDefi2: require('./ecosystem-new/project-logo/eco-defi-2.png'),
  ecoDefi3: require('./ecosystem-new/project-logo/eco-defi-3.png'),
  ecoDefi4: require('./ecosystem-new/project-logo/eco-defi-4.png'),
  ecoDefi5: require('./ecosystem-new/project-logo/eco-defi-5.png'),
  ecoDefi6: require('./ecosystem-new/project-logo/eco-defi-6.png'),
  ecoDefi7: require('./ecosystem-new/project-logo/eco-defi-7.png'),
  ecoDefi8: require('./ecosystem-new/project-logo/eco-defi-8.png'),
  ecoDefi9: require('./ecosystem-new/project-logo/eco-defi-9.png'),
  ecoDefi10: require('./ecosystem-new/project-logo/eco-defi-10.png'),

  ecoExchange1: require('./ecosystem-new/project-logo/eco-exchange-1.png'),
  ecoExchange2: require('./ecosystem-new/project-logo/eco-exchange-2.png'),
  ecoExchange3: require('./ecosystem-new/project-logo/eco-exchange-3.png'),
  ecoExchange4: require('./ecosystem-new/project-logo/eco-exchange-4.png'),
  ecoExchange5: require('./ecosystem-new/project-logo/eco-exchange-5.png'),
  ecoExchange6: require('./ecosystem-new/project-logo/eco-exchange-6.png'),
  ecoExchange7: require('./ecosystem-new/project-logo/eco-exchange-7.png'),
  ecoExchange8: require('./ecosystem-new/project-logo/eco-exchange-8.png'),
  ecoExchange9: require('./ecosystem-new/project-logo/eco-exchange-9.png'),
  ecoExchange10: require('./ecosystem-new/project-logo/eco-exchange-10.png'),
  ecoExchange11: require('./ecosystem-new/project-logo/eco-exchange-11.png'),
  ecoExchange12: require('./ecosystem-new/project-logo/eco-exchange-12.png'),
  ecoExchange13: require('./ecosystem-new/project-logo/eco-exchange-13.png'),
  ecoExchange14: require('./ecosystem-new/project-logo/eco-exchange-14.png'),
  ecoExchange15: require('./ecosystem-new/project-logo/eco-exchange-15.png'),
  ecoExchange16: require('./ecosystem-new/project-logo/eco-exchange-16.png'),
  ecoExchange17: require('./ecosystem-new/project-logo/eco-exchange-17.png'),

  ecoGamefi1: require('./ecosystem-new/project-logo/eco-gamefi-1.png'),
  ecoGamefi2: require('./ecosystem-new/project-logo/eco-gamefi-2.png'),
  ecoGamefi3: require('./ecosystem-new/project-logo/eco-gamefi-3.png'),
  ecoGamefi4: require('./ecosystem-new/project-logo/eco-gamefi-4.png'),
  ecoGamefi5: require('./ecosystem-new/project-logo/eco-gamefi-5.png'),
  ecoGamefi6: require('./ecosystem-new/project-logo/eco-gamefi-6.png'),
  ecoGamefi7: require('./ecosystem-new/project-logo/eco-gamefi-7.png'),
  ecoGamefi8: require('./ecosystem-new/project-logo/eco-gamefi-8.png'),
  ecoGamefi9: require('./ecosystem-new/project-logo/eco-gamefi-9.png'),
  ecoGamefi10: require('./ecosystem-new/project-logo/eco-gamefi-10.png'),
  ecoGamefi11: require('./ecosystem-new/project-logo/eco-gamefi-11.png'),

  ecoInfra1: require('./ecosystem-new/project-logo/eco-infra-1.png'),
  ecoInfra2: require('./ecosystem-new/project-logo/eco-infra-2.png'),
  ecoInfra3: require('./ecosystem-new/project-logo/eco-infra-3.png'),
  ecoInfra4: require('./ecosystem-new/project-logo/eco-infra-4.png'),
  ecoInfra5: require('./ecosystem-new/project-logo/eco-infra-5.png'),
  ecoInfra6: require('./ecosystem-new/project-logo/eco-infra-6.png'),
  ecoInfra7: require('./ecosystem-new/project-logo/eco-infra-7.png'),
  ecoInfra8: require('./ecosystem-new/project-logo/eco-infra-8.png'),
  ecoInfra9: require('./ecosystem-new/project-logo/eco-infra-9.png'),
  ecoInfra10: require('./ecosystem-new/project-logo/eco-infra-10.png'),
  ecoInfra11: require('./ecosystem-new/project-logo/eco-infra-11.png'),
  ecoInfra12: require('./ecosystem-new/project-logo/eco-infra-12.png'),
  ecoInfra13: require('./ecosystem-new/project-logo/eco-infra-13.png'),
  ecoInfra14: require('./ecosystem-new/project-logo/eco-infra-14.png'),
  ecoInfra15: require('./ecosystem-new/project-logo/eco-infra-15.png'),
  ecoInfra16: require('./ecosystem-new/project-logo/eco-infra-16.png'),
  ecoInfra17: require('./ecosystem-new/project-logo/eco-infra-17.png'),
  ecoInfra18: require('./ecosystem-new/project-logo/eco-infra-18.png'),
  ecoInfra19: require('./ecosystem-new/project-logo/eco-infra-19.png'),

  ecoNft1: require('./ecosystem-new/project-logo/eco-nft-1.png'),
  ecoNft2: require('./ecosystem-new/project-logo/eco-nft-2.png'),
  ecoNft3: require('./ecosystem-new/project-logo/eco-nft-3.png'),
  ecoNft4: require('./ecosystem-new/project-logo/eco-nft-4.png'),
  ecoNft5: require('./ecosystem-new/project-logo/eco-nft-5.png'),
  ecoNft6: require('./ecosystem-new/project-logo/eco-nft-6.png'),
  ecoNft7: require('./ecosystem-new/project-logo/eco-nft-7.png'),
  ecoNft8: require('./ecosystem-new/project-logo/eco-nft-8.png'),
  ecoNft9: require('./ecosystem-new/project-logo/eco-nft-9.png'),
  ecoNft10: require('./ecosystem-new/project-logo/eco-nft-10.png'),
  ecoNft11: require('./ecosystem-new/project-logo/eco-nft-11.png'),
  ecoNft12: require('./ecosystem-new/project-logo/eco-nft-12.png'),
  ecoNft13: require('./ecosystem-new/project-logo/eco-nft-13.png'),
  ecoNft14: require('./ecosystem-new/project-logo/eco-nft-14.png'),
  ecoNft15: require('./ecosystem-new/project-logo/eco-nft-15.png'),

  ecoOther1: require('./ecosystem-new/project-logo/eco-other-1.png'),
  ecoOther2: require('./ecosystem-new/project-logo/eco-other-2.png'),
  ecoOther3: require('./ecosystem-new/project-logo/eco-other-3.png'),

  masternodeBanner: require('./masternode/masternode-banner.png'),
  lineCurve: require('./masternode/line-curve.png'),
  bannerBottom: require('./masternode/banner-bottom.png'),
  coinBannerBottom: require('./masternode/coin-banner-bottom.png'),
  starBannerBottom: require('./masternode/star-banner-bottom.png'),
  masternodeHearthBanner: require('./masternode/masternode-hearth-banner.png'),
  rewardShare: require('./masternode/reward-share.png'),
  setupGuide: require('./masternode/setup-guide.png'),

  bridge1: require('./bridge-screen/bridge-1.png'),
  bridge2: require('./bridge-screen/bridge-2.png'),
  bridge3: require('./bridge-screen/bridge-3.png'),
  bridge4: require('./bridge-screen/bridge-4.png'),
  bridge5: require('./bridge-screen/bridge-5.png'),
  bridge6: require('./bridge-screen/bridge-6.png'),
  bridge7: require('./bridge-screen/bridge-7.png'),
  bridge8: require('./bridge-screen/bridge-8.png'),
  bridge9: require('./bridge-screen/bridge-9.png'),

  walletGateway1: require('./gateway/wallet-gateway-1.png'),
  walletGateway2: require('./gateway/wallet-gateway-2.png'),
  walletGateway3: require('./gateway/wallet-gateway-3.png'),
  walletGateway4: require('./gateway/wallet-gateway-4.png'),
  walletGateway5: require('./gateway/wallet-gateway-5.png'),
  walletGateway6: require('./gateway/wallet-gateway-6.png'),
  walletGateway7: require('./gateway/wallet-gateway-7.png'),
  walletGateway8: require('./gateway/wallet-gateway-8.png'),
  walletGateway9: require('./gateway/wallet-gateway-9.png'),
  walletGateway10: require('./gateway/wallet-gateway-10.png'),
  walletGateway11: require('./gateway/wallet-gateway-11.png'),
  walletGateway12: require('./gateway/wallet-gateway-12.png'),
  walletGateway13: require('./gateway/wallet-gateway-13.png'),
  walletGateway14: require('./gateway/wallet-gateway-14.png'),
  walletGateway15: require('./gateway/wallet-gateway-15.png'),
  walletGateway16: require('./gateway/wallet-gateway-16.png'),
  walletGateway17: require('./gateway/wallet-gateway-17.png'),
  walletGateway18: require('./gateway/wallet-gateway-18.png'),
  walletGateway19: require('./gateway/wallet-gateway-19.png'),
  walletGateway20: require('./gateway/wallet-gateway-20.png'),
  walletGateway21: require('./gateway/wallet-gateway-21.png'),
  walletGateway22: require('./gateway/wallet-gateway-22.png'),
  walletGateway23: require('./gateway/wallet-gateway-23.png'),
  walletGateway24: require('./gateway/wallet-gateway-24.png'),
  walletGateway25: require('./gateway/wallet-gateway-25.png'),
  walletGateway26: require('./gateway/wallet-gateway-26.png'),
  walletGateway27: require('./gateway/wallet-gateway-27.png'),
  walletGateway28: require('./gateway/wallet-gateway-28.png'),
  walletGateway29: require('./gateway/wallet-gateway-29.png'),
  walletGateway30: require('./gateway/wallet-gateway-30.png'),
  walletGateway31: require('./gateway/wallet-gateway-31.png'),
  walletGateway32: require('./gateway/wallet-gateway-32.png'),
  walletGateway33: require('./gateway/wallet-gateway-33.png'),
  walletGateway34: require('./gateway/wallet-gateway-34.png'),

  exchangeGateway1: require('./gateway/exchange-gateway-1.png'),
  exchangeGateway2: require('./gateway/exchange-gateway-2.png'),
  exchangeGateway3: require('./gateway/exchange-gateway-3.png'),
  exchangeGateway4: require('./gateway/exchange-gateway-4.png'),
  exchangeGateway5: require('./gateway/exchange-gateway-5.png'),
  exchangeGateway6: require('./gateway/exchange-gateway-6.png'),
  exchangeGateway7: require('./gateway/exchange-gateway-7.png'),
  exchangeGateway8: require('./gateway/exchange-gateway-8.png'),
  exchangeGateway9: require('./gateway/exchange-gateway-9.png'),
  exchangeGateway10: require('./gateway/exchange-gateway-10.png'),
  exchangeGateway11: require('./gateway/exchange-gateway-11.png'),
  exchangeGateway12: require('./gateway/exchange-gateway-12.png'),
  exchangeGateway13: require('./gateway/exchange-gateway-13.png'),
  exchangeGateway14: require('./gateway/exchange-gateway-14.png'),
  exchangeGateway15: require('./gateway/exchange-gateway-15.png'),
  exchangeGateway16: require('./gateway/exchange-gateway-16.png'),
  exchangeGateway17: require('./gateway/exchange-gateway-17.png'),

  bgBannerGetStarted: require('./get-started/bg-banner-started.png'),
  creamCurve: require('./get-started/cream-curve.png'),
  walletImg: require('./get-started/wallet-img.png'),
  userImg: require('./get-started/user-img.png'),
  noteImg: require('./get-started/note-img.png'),
  curveBlackBottom: require('./curve-black-bottom.png'),

  transfer1: require('./get-started/transfer-1.png'),
  transfer2: require('./get-started/transfer-2.png'),
  transfer3: require('./get-started/transfer-3.png'),

  utilityBanner: require('./utility/utility-banner.png'),
  utilityCoin: require('./utility/utility-coin.png'),

  hubBanner: require('./developer-hub-new/hub-banner.png'),
  curveUpBlack2: require('./curve-up-black-2.png'),
  curveBorder: require('./developer-hub-new/curve-border.png'),

  iconConnect: require('./developer-hub-new/icon-connect.svg').default,
  iconStake: require('./developer-hub-new/icon-stake.svg').default,
  iconGas: require('./developer-hub-new/icon-gas.svg').default,
  iconTele: require('./developer-hub-new/icon-tele.svg').default,
  iconBlock: require('./developer-hub-new/icon-block.svg').default,

  iconFile: require('./developer-hub-new/icon-file.png'),
  iconMasterNode: require('./developer-hub-new/icon-masternode.png'),
  iconSquare: require('./developer-hub-new/icon-square.png'),
  bannerEvent1: require('./developer-hub-new/banner-event-1.png'),
  bannerEvent2: require('./developer-hub-new/banner-event-2.png'),

  iconDiscord: require('./developer-hub-new/icon-discord.png'),
  iconGmail: require('./developer-hub-new/icon-gmail.png'),
  iconViction: require('./developer-hub-new/icon-viction.png'),

  buildIcon1: require('./developer-hub-new/build-icon/build-icon-1.png'),
  buildIcon2: require('./developer-hub-new/build-icon/build-icon-2.png'),
  buildIcon3: require('./developer-hub-new/build-icon/build-icon-3.png'),
  buildIcon4: require('./developer-hub-new/build-icon/build-icon-4.png'),
  buildIcon5: require('./developer-hub-new/build-icon/build-icon-5.png'),
  buildIcon6: require('./developer-hub-new/build-icon/build-icon-6.png'),
  buildIcon7: require('./developer-hub-new/build-icon/build-icon-7.png'),
  buildIcon8: require('./developer-hub-new/build-icon/build-icon-8.png'),
  buildIcon9: require('./developer-hub-new/build-icon/build-icon-9.png'),
  buildIcon10: require('./developer-hub-new/build-icon/build-icon-10.png'),
  buildIcon11: require('./developer-hub-new/build-icon/build-icon-11.png'),
  buildIcon12: require('./developer-hub-new/build-icon/build-icon-12.png'),
  buildIcon13: require('./developer-hub-new/build-icon/build-icon-13.png'),
  buildIcon14: require('./developer-hub-new/build-icon/build-icon-14.png'),
  buildIcon15: require('./developer-hub-new/build-icon/build-icon-15.png'),
  buildIcon16: require('./developer-hub-new/build-icon/build-icon-16.png'),
  buildIcon17: require('./developer-hub-new/build-icon/build-icon-17.png'),
  buildIcon18: require('./developer-hub-new/build-icon/build-icon-18.png'),
  buildIcon19: require('./developer-hub-new/build-icon/build-icon-19.png'),
  buildIcon20: require('./developer-hub-new/build-icon/build-icon-20.png'),
  buildIcon21: require('./developer-hub-new/build-icon/build-icon-21.png'),
  buildIcon22: require('./developer-hub-new/build-icon/build-icon-22.png'),
  buildIcon23: require('./developer-hub-new/build-icon/build-icon-23.png'),
  buildIcon24: require('./developer-hub-new/build-icon/build-icon-24.png'),
  buildIcon25: require('./developer-hub-new/build-icon/build-icon-25.png'),
  buildIcon26: require('./developer-hub-new/build-icon/build-icon-26.png'),
  curveGrey: require('./developer-hub-new/curve-grey.png'),

  communityBanner1: require('./community-hub-new/community-banner-1.png'),
  communityBanner2: require('./community-hub-new/community-banner-2.png'),
  communityBanner3: require('./community-hub-new/community-banner-3.png'),
  communityBanner4: require('./community-hub-new/community-banner-4.png'),
  communityBanner5: require('./community-hub-new/community-banner-5.png'),
  communityBanner6: require('./community-hub-new/community-banner-6.png'),
  communityBanner7: require('./community-hub-new/community-banner-7.png'),
  communityBanner8: require('./community-hub-new/community-banner-8.png'),
  communityBanner9: require('./community-hub-new/community-banner-9.png'),
  communityBanner10: require('./community-hub-new/community-banner-10.png'),
  curveWhite: require('./community-hub-new/curve-white.png'),

  eventCall1: require('./event-new/event-call-1.png'),
  eventCall2: require('./event-new/event-call-2.png'),
  eventCall3: require('./event-new/event-call-3.png'),
  eventCall4: require('./event-new/event-call-4.png'),
  tower: require('./tower.png'),

  bdVicLottie: require('./lottie/bd-vic.json'),
  fingerV: require('./finger-v.png'),

  tabIrl1: require('./event-new/tab-irl-1.png'),
  tabIrl2: require('./event-new/tab-irl-2.png'),
  tabIrl3: require('./event-new/tab-irl-3.png'),
  tabIrl4: require('./event-new/tab-irl-4.png'),
  tabIrl5: require('./event-new/tab-irl-5.png'),
  tabIrl6: require('./event-new/tab-irl-6.png'),
  tabIrl7: require('./event-new/tab-irl-7.png'),
  tabIrl8: require('./event-new/tab-irl-8.png'),
  tabIrl9: require('./event-new/tab-irl-9.png'),
  tabIrl10: require('./event-new/tab-irl-10.png'),
  tabIrl11: require('./event-new/tab-irl-11.png'),
  tabIrl12: require('./event-new/tab-irl-12.png'),
  tabIrl13: require('./event-new/tab-irl-13.png'),
  tabIrl14: require('./event-new/tab-irl-14.png'),
  tabIrl15: require('./event-new/tab-irl-15.png'),

  tabEvent1: require('./event-new/tab-event-1.png'),
  tabEvent2: require('./event-new/tab-event-2.png'),
  tabEvent3: require('./event-new/tab-event-3.png'),
  tabEvent4: require('./event-new/tab-event-4.png'),
  tabEvent5: require('./event-new/tab-event-5.png'),
  tabEvent6: require('./event-new/tab-event-6.png'),
  tabEvent7: require('./event-new/tab-event-7.png'),
  tabEvent8: require('./event-new/tab-event-8.png'),
  tabEvent9: require('./event-new/tab-event-9.png'),
  tabEvent10: require('./event-new/tab-event-10.png'),
  tabEvent11: require('./event-new/tab-event-11.png'),

  discordIcon: require('./discord-icon.png'),
  telegramIcon: require('./telegram-icon.png'),
  youtubeIcon: require('./youtube-icon.png'),
  xIcon: require('./x-icon.png'),
  githubIcon: require('./github-icon.png'),

  programEvent: require('./community-hub-new/example-program-event.png'),
  programEvent2: require('./community-hub-new/example-program-event-2.png'),
  programEvent3: require('./community-hub-new/example-program-event-3.png'),

  programEventExample: require('./community-hub-new/program-event-example.png'),

  communityFrontier1: require('./community-hub-new/community-frontier-1.png'),
  communityFrontier2: require('./community-hub-new/community-frontier-2.png'),
  communityFrontier3: require('./community-hub-new/community-frontier-3.png'),
  communityFrontier4: require('./community-hub-new/community-frontier-4.png'),
  communityFrontier5: require('./community-hub-new/community-frontier-5.png'),
  communityFrontier6: require('./community-hub-new/community-frontier-6.png'),
  communityFrontier7: require('./community-hub-new/community-frontier-7.png'),
  communityFrontier8: require('./community-hub-new/community-frontier-8.png'),

  communityGovernance1: require('./community-hub-new/community-governance-1.png'),
  communityGovernance2: require('./community-hub-new/community-governance-2.png'),

  blogNew1: require('./community-hub-new/blog-new-1.png'),
  blogNew2: require('./community-hub-new/blog-new-2.png'),
  blogNew3: require('./community-hub-new/blog-new-3.png'),

  curveBlack2: require('./curve-black-2.png'),
}

export default images
